import R from 'ramda';
import validate from 'validate.js';

export const firstError = R.curry(
  (errors, field) => (errors[field] ? errors[field][0] : ''),
);

export const validateField = R.curry((constraints, field, value, errors) => {
  const results = validate.single(value, constraints[field]);

  return results
    ? R.merge(errors, { [field]: results })
    : R.omit([field], errors);
});

export const validateObject = R.curry((constraints, obj) =>
  validate(obj, constraints),
);



// WEBPACK FOOTER //
// ./src/common/validation.js